(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.factory('AgendaService', ['$http', '$q', 'HelperService', 'DateService', AgendaServiceFn]);

    /* service for requesting agenda  */
    function AgendaServiceFn($http, $q, HelperService, DateService) {
        var baseUrl = '/api/agendas/';

        var service = {
            get: get,
            deactivate: deactivate,
            update: update,
            day: day,
            week: week,
            firstFreeAppointments: firstFreeAppointments,
            block: block,
            synchronize: synchronize,
            onlyFreeAgendaItems: onlyFreeAgendaItems
        };

        return service;

        /* get agenda (also deactivated ones!) */
        function get(agendaId) {
            return $http.get(baseUrl + agendaId).then(function (response) {
                return response.data;
            });
        }

        /* deactivate agenda */
        function deactivate(agendaId) {
            return $http.delete(baseUrl + agendaId).then(function (response) {
                return response.data;
            });
        }

        /* update agenda */
        function update(agendaId, item) {
            return $http.put(baseUrl + agendaId, item).then(function (response) {
                return response.data;
            });
        }

        /* synchronize agenda reminders */
        function synchronize(agendaId, item) {
            return $http.put(baseUrl + agendaId + '/reminders').then(function (response) {
                return response.data;
            });
        }

       
        /* get agenda-day for date */
        function day(agendaId, date) {
            return $http.get(baseUrl + agendaId + '/day/' + HelperService.backendDate(date)).then(function (response) {
                return response.data;
            });
        }

        /* only free agenda-items (labels) */
        function onlyFreeAgendaItems(agendaId, date) {
            return $http.get(baseUrl + agendaId + '/labels/' + HelperService.backendDate(date)).then(function (response) {
                return response.data;
            });
        }

        /* get agenda-week for date */
        function week(agendaId, date) {
            return $http.get(baseUrl + agendaId + '/week/' + HelperService.backendDate(date)).then(function (response) {
                return response.data;
            });
        }


        /* get list of first free appointments */
        function firstFreeAppointments(agendaIds, agendaLabelIds, weekdays, dateFrom, timeFrom, timeTo, loadMore) {
            var deferred = $q.defer();
            var promises = [];
            var i = 0;
            var len = agendaIds.length;
            // all calls 
            for (i; i < len; i++) {
                promises.push(callFFE(agendaIds[i], agendaLabelIds, weekdays, dateFrom, timeFrom, timeTo, loadMore));
            }

            $q.all(promises).then(function (promiseResults) {
                deferred.resolve(promiseResults);
            }, function (errorResult) {
                deferred.reject(errorResult.data);
            });

            return deferred.promise;
        }

        // Call FFE
        function callFFE(id, agendaLabelIds, weekdays, dateFrom, timeFrom, timeTo, loadMore) {
            return $http({
                url: baseUrl + id + '/firstfreeappointments',
                method: 'GET',
                params: { // dates/times are already converted to backend date in daterange/timerange directives
                    agendaLabelIds: agendaLabelIds ? agendaLabelIds : null,
                    weekdays: weekdays ? weekdays : null,
                    dateFrom: dateFrom,
                    timeFrom: timeFrom ? timeFrom : null,
                    timeTo: timeTo ? timeTo : null,
                    loadMore: loadMore ? loadMore : false
                }
            }).then(function (response) {
                return response.data;
            });
        }



        /* block agenda items */
        function block(agendaId, duration, description) {
            return $http({
                url: baseUrl + agendaId + '/block/' + HelperService.backendDate(DateService.data.date),
                method: 'PUT',
                data: {
                    duration: duration,
                    description: description
                }
            }).then(function (response) {
                return response.data;
            });
        }


    }
})();